// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entity-list {
  display: grid;
  grid-template-columns: 7rem auto;
  padding: 0 1rem 1rem 0;
  row-gap: 1rem;

  .card {
    border-top: var(--border-width) solid transparent;
    border-bottom: var(--border-elevated);
    display: grid;
    grid-column: span 2;
    grid-template-columns: subgrid;
    margin-top: 1rem;
    position: relative;
    row-gap: 0.7rem;

    &.confirming {
      & .data-item .data-value,
      & .aqumen-id .data-label,
      & .aqumen-id .display-id {
        color: var(--color-elevated-warn) !important;
        transition: none;
      }
    }
    .card-data,
    .card-data .data-item {
      display: grid;
      grid-column: span 2;
      grid-template-columns: subgrid;
      column-gap: 1rem;
      row-gap: 0.7rem;
    }

    .card-data .data-item {
      .data-label {
        color: var(--color-base-text);
        display: unset;
        grid-column: 1;
        text-align: right;
      }

      .data-value {
        grid-column: 2;

        input, select {
          width: calc(100% - 1rem);
          width: 100%;
        }
        input[type="datetime-local"] {
          width: calc(100% - 1.3rem);
        }
        input[type="number"] {
          width: calc(100% - 1.1rem);
        }
        textarea {
          width: calc(100% - 1rem);
        }
      }
    }
  }

  .card-title {
    grid-column: span 2;
    margin: 0;
    padding-left: 7.5rem;
  }

  .card-metadata {
    position: absolute; top: 0; right: 0;
  }

  .card-actions {
    grid-column: span 2;
    padding: 1rem 0;
    text-align: right;

    .create-button,
    .archive-button {
      width: 7rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/entity_list.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;;EAEb;IACE,iDAAiD;IACjD,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;;IAEf;MACE;;;QAGE,4CAA4C;QAC5C,gBAAgB;MAClB;IACF;IACA;;MAEE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE;QACE,6BAA6B;QAC7B,cAAc;QACd,cAAc;QACd,iBAAiB;MACnB;;MAEA;QACE,cAAc;;QAEd;UACE,wBAAwB;UACxB,WAAW;QACb;QACA;UACE,0BAA0B;QAC5B;QACA;UACE,0BAA0B;QAC5B;QACA;UACE,wBAAwB;QAC1B;MACF;IACF;EACF;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,kBAAkB,EAAE,MAAM,EAAE,QAAQ;EACtC;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;;IAEjB;;MAEE,WAAW;IACb;EACF;AACF","sourcesContent":[".entity-list {\n  display: grid;\n  grid-template-columns: 7rem auto;\n  padding: 0 1rem 1rem 0;\n  row-gap: 1rem;\n\n  .card {\n    border-top: var(--border-width) solid transparent;\n    border-bottom: var(--border-elevated);\n    display: grid;\n    grid-column: span 2;\n    grid-template-columns: subgrid;\n    margin-top: 1rem;\n    position: relative;\n    row-gap: 0.7rem;\n\n    &.confirming {\n      & .data-item .data-value,\n      & .aqumen-id .data-label,\n      & .aqumen-id .display-id {\n        color: var(--color-elevated-warn) !important;\n        transition: none;\n      }\n    }\n    .card-data,\n    .card-data .data-item {\n      display: grid;\n      grid-column: span 2;\n      grid-template-columns: subgrid;\n      column-gap: 1rem;\n      row-gap: 0.7rem;\n    }\n\n    .card-data .data-item {\n      .data-label {\n        color: var(--color-base-text);\n        display: unset;\n        grid-column: 1;\n        text-align: right;\n      }\n\n      .data-value {\n        grid-column: 2;\n\n        input, select {\n          width: calc(100% - 1rem);\n          width: 100%;\n        }\n        input[type=\"datetime-local\"] {\n          width: calc(100% - 1.3rem);\n        }\n        input[type=\"number\"] {\n          width: calc(100% - 1.1rem);\n        }\n        textarea {\n          width: calc(100% - 1rem);\n        }\n      }\n    }\n  }\n\n  .card-title {\n    grid-column: span 2;\n    margin: 0;\n    padding-left: 7.5rem;\n  }\n\n  .card-metadata {\n    position: absolute; top: 0; right: 0;\n  }\n\n  .card-actions {\n    grid-column: span 2;\n    padding: 1rem 0;\n    text-align: right;\n\n    .create-button,\n    .archive-button {\n      width: 7rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
